import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";
import {myAcademy} from "@/lib/services/academyService";

export const useApiLmGroupList = (config) => {
    return useQuery({
        queryKey: ['lms', 'group', 'list', config, myAcademy()],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/lms/groups`, config)
        })({params: config})),
    })
}


export const useApiLmLevelList = (groupId, config) => {
    return useQuery({
        queryKey: ['lms', 'group', 'level', groupId, 'list', config, myAcademy()],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/lms/levels`, config)
        })({params: {group_id: groupId, ...config}})),
    })
}


export const useApiLmLevelDetail = (id, config) => {
    return useQuery({
        queryKey: ['lms', 'group', 'level', id, 'detail', config, myAcademy()],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/lms/levels/${config.id}`, config)
        })({id: id, params: {id: id, ...config}})),
    })
}

export const useApiLmsSaveFileUploaded = () => {
    return useMutation({
        mutationFn: (args) =>
            ((async (data) => {
                return generalRequest.post(`/lms/levels/${data.id}/upload`, data)
            })(args))
    });
}


export const useApiLmsSaveAnswer = () => {
    return useMutation({
        mutationFn: (args) =>
            ((async (data) => {
                return generalRequest.post(`/lms/levels/${data.id}/answer`, data)
            })(args))
    });
}

